import React from "react";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../../framework/helpers/BreakpointHelper";
import LazyImage from "../../../framework/lazy/LazyImage";
import {BaseHeader, Paragraph} from "BaseComponents/Text";
import {RTEWrapper} from "BaseComponents/Wrappers";
import {getButtonColor} from "Helpers/ColorHelper";
import {ButtonText as BtnText, ColoredButton} from "BaseComponents/Button";

export const ServicePackageCard = ({
                                       Id,
                                       Alias,
                                       Title,
                                       Icon,
                                       Preamble,
                                       Price,
                                       PriceWithTax,
                                       Text,
                                       ButtonText,
                                       ButtonColor,
                                       TextNearPriceWithoutTax,
                                       Link
                                   }) => {
    const {color, textColor} = getButtonColor(ButtonColor);

    return <ServicePackageCardWrapper key={Id} className={`${Alias}`}>
        <ServicePackageCardTextWrapper className={"pt-8 px-5 servicePackageCardTextWrapper"}>
            {Icon && <LazyImage
                source={Icon}
                height="60px"
                display="block"
            />}
            <BaseHeader
                inline
                margin="0"
                marginsmall="0"
                fontWeight="400"
                size="28px"
                textAlign="center">
                {Title}
            </BaseHeader>
            <Paragraph center fontSize={"18px"}>{Preamble}</Paragraph>
            <Paragraph center fontSize={"32px"} fontSizeSmall={'24px'} bold>{Price}</Paragraph>
            <Paragraph center>{TextNearPriceWithoutTax} {PriceWithTax}</Paragraph>
            <RTEWrapper
                maring={"0"}
                dangerouslySetInnerHTML={{
                    __html: Text,
                }}
            ></RTEWrapper>
        </ServicePackageCardTextWrapper>
        {!!Link &&
            <ColoredButton
                inverted
                href={`${Link.Url}?cardId=${Id}`}
                width="100%"
                target={Link.Target}
                aria-label={Link.Name}
                padding="1rem 0"
                smallpadding="0"
                margin={"0"}
                bgColor={color}
                smallmargin={"0"}
            >
                <BtnText fontSize={"18px"} color={textColor} className={"customColor"}
                         heading={ButtonText}>{ButtonText}</BtnText>
            </ColoredButton>}
    </ServicePackageCardWrapper>
}

export const ServicePackageCardWrapper = styled.div.attrs(({}) => ({}))`
    color: ${({theme}) => theme.colors.black};
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    overflow: hidden;
    flex-basis: calc(100% / 4 - (2rem * 3 / 4));

    ${media.lessThan(breakpoints.desktop)`   
        flex-basis: calc(100% / 2 - (2rem * 2 / 2)); 
    `}
    ${media.lessThan(breakpoints.mobile)`   
        flex-basis: 100%; 
    `}
    button, a {
        border-top-right-radius: 0;
        border-top-left-radius: 0;
    }
`;

export const ServicePackageCardTextWrapper = styled.div.attrs(({}) => ({}))`
    width: 100%;
    flex: 1;
    background-color: ${({theme}) => theme.colors.white};
    color: ${({theme}) => theme.colors.black};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    ${media.lessThan(breakpoints.ipad)`
  `}
    img {
        height: 60px;
        width: 60px;
    }
`;